import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '@components/button/button.module';
import { ButtonGroupComponent } from './button-group.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule
  ],
  declarations: [ButtonGroupComponent],
  exports: [ButtonGroupComponent]
})
export class ButtonGroupModule {}
